/**
 * Created by ljybill@aliyun.com  on 2018/5/28
 */
import Login from '@/views/Login'
import register from '@/views/register'
import Main from '@/views/Main'
import Token from '@/views/token'
import LoginFake from '@/views/Login-fake'
import setNickName from '@/views/setNickName'
import OrganizeLogin from '@/views/OrganizeLogin'
import OrgApply from '@/views/OrganizeApply'
import forgetPwd from '@/views/forgetPwd'

export const redirectionRouter = {
  path: '/',
  redirect: '/square'
}

export const LoginRouter = {
  path: '/login',
  name: 'login',
  component: Login
}

export const registerRouter = {
  path: '/register',
  name: 'register',
  component: register
}

export const TokenRouter = {
  path: '/token',
  name: 'token',
  component: Token
}

export const setNickNameRouter = {
  path: '/setNickName',
  name: 'setNickName',
  component: setNickName
}

export const forgetPwdRouter = {
  path: '/forgetPwd',
  name: 'forgetPwd',
  component: forgetPwd
}

export const LoginFakeRouter = {
  path: '/login/f',
  name: 'login_fake',
  component: LoginFake
}

export const OrganizeLoginRouter = {
  path: '/organizeLogin',
  name: 'organizeLogin',
  component: OrganizeLogin
}
export const OrgApplyRouter = {
  path: '/orgApply',
  name: 'orgApply',
  component: OrgApply
}

export const appRouter = {
  path: '/',
  name: 'main',
  component: Main,
  children: [
    {
      path: '/square',
      title: '问题广场',
      name: 'answer_square',
      component: () => import('@/views/answers/square-answer')
    },
    {
      path: '/wait',
      title: '待回答',
      name: 'answer_wait',
      component: () => import('@/views/answers/wait-answer')
    },
    {
      path: '/answer',
      title: '我的回答',
      name: 'mine_answer',
      component: () => import('@/views/mine/mine-answer')
    },
    {
      path: '/profit',
      title: '我的收益',
      name: 'mine_profit',
      component: () => import('@/views/mine/mine-profit')
    },
    {
      path: '/fans',
      title: '我的粉丝',
      name: 'mine_fans',
      component: () => import('@/views/mine/mine-fans')
    },
    {
      path: '/notice',
      title: '通知',
      name: 'mine-notice',
      component: () => import('@/views/notice/notice')
    },
    {
      path: '/edit/:id',
      title: '回答问题',
      name: 'edit_answer',
      component: () => import('@/views/edit/editorAnswer.vue')
    },
    {
      path: '/draft',
      title: '草稿箱',
      name: 'mine_draft',
      component: () => import('@/views/mine/mine-draft.vue')
    },
    {
      path: '/answer/:id',
      title: '问答详情',
      name: 'answer_detail',
      component: () => import('@/views/answers/detail-answer.vue')
    },
    {
      path: '/take',
      title: '提现',
      name: 'take_money',
      component: () => import('@/views/take/take-money.vue')
    },
    {
      path: '/recode',
      title: '提现记录',
      name: 'take_recode',
      component: () => import('@/views/take/take-recode.vue')
    },
    {
      path: '/detail/:id',
      title: '提现明细',
      name: 'take_detail',
      component: () => import('@/views/take/take-detail.vue')
    }
  ]
}

export const routers = [
  redirectionRouter,
  LoginRouter,
  setNickNameRouter,
  appRouter,
  LoginFakeRouter,
  TokenRouter,
  registerRouter,
  OrganizeLoginRouter,
  forgetPwdRouter,
  OrgApplyRouter
]



// WEBPACK FOOTER //
// ./src/router/routes.js